import { yupResolver } from "@hookform/resolvers/yup";
import { AlertColor } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import ButtonGeneric from "../../components/ButtonGeneric";
import InputGeneric from "../../components/InputGeneric";
import PageWrapper from "../../components/PageWrapper/index";
import PreloadFb from "../../components/Preload";
import PreloadButton from "../../components/PreloadButton";
import Toast from "../../components/Toast";
import { useAuth } from "../../contexts/contexts";
import { api } from "../../services/api";
import { FormLeadSourceEditPage } from "./styles";

type leadSourceFormTypeValues = {
    name: string;
};

const leadSourceFormSchema = yup.object().shape({
    name: yup.string().required(),
});

function LeadSourceEditPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");
    const navigate = useNavigate();
    const { hasPermissions, permissions } = useAuth();
    useEffect(() => {
        if (
            hasPermissions("origem.lead.editar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    // toast configs
    const [openToast, setOpenToast] = useState(false);
    function handleCloseToast() {
        setOpenToast(false);
    }
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [isLoadingButton, setIsLoadingButton] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm<leadSourceFormTypeValues>({
        resolver: yupResolver(leadSourceFormSchema),
    });

    useEffect(() => {
        api.get(`/leadSource/${myParam}`)
            .then((response) => {
                setValue("name", response.data.response.name);
                setIsLoading(false);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.message);
            });
    }, [myParam, setValue]);

    const editHolderType: SubmitHandler<leadSourceFormTypeValues> = async (
        formValues
    ) => {
        setIsLoadingButton(true);
        api.put(`/leadSource/${myParam}`, {
            name: formValues.name,
        })
            .then((response) => {
                setOpenToast(true);
                setToastRequisitionResult("success");
                setTextToast(response.data.message);
            })
            .then(() => {
                setTimeout(() => {
                    navigate("/settings/leadsSource");
                    setOpenToast(false);
                    setIsLoadingButton(false);
                }, 2000);
            })
            .catch((response) => {
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast(response.response.data.response.name);
                setIsLoadingButton(false);
            });
    };

    return (
        <>
            <PageWrapper>
                {isLoading ? (
                    <PreloadFb />
                ) : (
                    <FormLeadSourceEditPage>
                        <div className="topFormPage">
                            <h2>Editar Lead</h2>
                        </div>
                        <form onSubmit={handleSubmit(editHolderType)}>
                            <div className="inputsContainer">
                                <Controller
                                    control={control}
                                    name="name"
                                    render={({
                                        field: {
                                            onChange,
                                            onBlur,
                                            value = "",
                                            ref,
                                        },
                                    }) => (
                                        <InputGeneric
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            value={value}
                                            size="small"
                                            className="inputs"
                                            label="Nome"
                                            error={!!errors.name}
                                            ref={ref}
                                            autoFocus
                                        />
                                    )}
                                />
                            </div>
                            <div className="buttonsContainer">
                                <ButtonGeneric
                                    onclick={() =>
                                        navigate("/settings/leadsSource")
                                    }
                                    buttonColor="var(--cancel)"
                                    text="VOLTAR"
                                />
                                <PreloadButton
                                    colorText="white"
                                    background="var(--confirm)"
                                    loading={isLoadingButton}
                                    text="CONFIRMAR"
                                    type="submit"
                                />
                            </div>
                        </form>
                    </FormLeadSourceEditPage>
                )}
            </PageWrapper>
            <Toast
                open={openToast}
                onClose={() => handleCloseToast()}
                severity={toastRequisitionResult}
                text={textToast}
            />
        </>
    );
}
export default LeadSourceEditPage;
